import {convertDateToPrintString} from "../../../../Utilities/Types/dateUtilities";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import type { BraillerLoanManagementApiItem, BraillerLoanManagementItem, BraillerLoanManagementUpdateItem } from "../brailler.types";

export const braillerLoanManagementItemModel = (item: BraillerLoanManagementApiItem): BraillerLoanManagementItem => ({
    id: item.id,
    type: item.type,

    // Loan-specific fields
    braillerLoanId: item.braillerLoanId,
    loanStatus: item.loanStatus,
    dateCheckedOut: item.dateCheckedOut,
    dateCheckedOutFormatted: !isNullOrUndefined(item.dateCheckedOut) ? convertDateToPrintString(item.dateCheckedOut) : "",
    dateDue: item.dateDue,
    dateReturned: item.dateReturned,
    isOverdue: item.isOverdue,

    // Repair-specific fields
    braillerRepairId: item.braillerRepairId,
    repairStatus: item.repairStatus,
    repairDate: item.repairDate,
    completedDate: item.completedDate,
    issue: item.issue,
    resolution: item.resolution,
    repairCost: item.repairCost,
    reportedBy: item.reportedBy,
    repairedBy: item.repairedBy,
    replacementPreference: item.replacementPreference,
    replacementLoanId: item.replacementLoanId,
    hasReplacementLoan: item.hasReplacementLoan || !!item.replacementLoanId,

    // Common fields
    patronId: item.patronId,
    patronName: item.patronName,
    patron: item.patron,
    studentId: item.studentId,
    student: item.student,
    studentName: item.studentName,
    braillerCatalogItemId: item.braillerCatalogItemId,
    catalogTitle: item.catalogTitle,
    model: item.model,
    serialNumber: item.serialNumber,
    inventoryNotes: item.inventoryNotes,
    braillerInventoryItemId: item.braillerInventoryItemId,
    shippingLocationId: item.shippingLocationId,
    shippingLocationName: item.shippingLocationName,
    shippingLocation: item.shippingLocation,
    notes: item.type === 'Loan' ? item.braillerLoanNotes : item.resolution,
    dateCreatedUtc: item.dateCreatedUtc,
    dateCreatedFormatted: !isNullOrUndefined(item.dateCreatedUtc) ? convertDateToPrintString(item.dateCreatedUtc) : "",
    dateModifiedUtc: item.dateModifiedUtc,
});

export const updateBraillerLoanManagementItemModel = (item: BraillerLoanManagementItem): BraillerLoanManagementUpdateItem => {
    if (item.type === 'Loan') {
        return {
            braillerLoanId: item.braillerLoanId,
            braillerLoanStatus: item.loanStatus,
            braillerLoanNotes: item.notes,
            inventoryNotes: item.inventoryNotes,
            serialNumber: item.serialNumber,
        };
    } else {
        return {
            id: item.braillerRepairId,
            issue: item.issue,
            resolution: item.notes,
            repairedBy: item.repairedBy || '',
            status: item.repairStatus,
            repairCost: item.repairCost,
            serialNumber: item.serialNumber,
            inventoryNotes: item.inventoryNotes,
            replacementPreference: item.replacementPreference,
        };
    }
};

export const emptyBraillerLoanManagementSearchCriteria = {
    includeLoans: true,
    includeRepairs: true,
    includeUnloaned: true,
    loanStatus: null,
    repairStatus: null,
    braillerCatalogItemId: null,
    patronId: null,
    shippingLocationId: null,
    startDate: null,
    endDate: null,
    searchKeyword: '',
    page: 1,
    recordsPerPage: 25,
    sortByColumn: '',
    sortDescending: false,
};
